import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useDashboard } from '../../hooks/useDashboard';
import { Header } from '../Header';
import { ErrorDisplay } from '../ErrorDisplay';
import { DateRangeFilter } from '../DateRangeFilter';
import { MetricsPanel } from '../MetricsPanel';
import { CostPanel } from '../CostPanel';
import { AlertsPanel } from '../AlertsPanel';
import { WorkersPanel } from '../WorkersPanel';
import { PerformancePanel } from '../PerformancePanel';
export function MonitoringPage() {
    const { metrics, workers, alerts, cost, performance, recommendations, queries, isConnected, isLoading, error, dateRange, setDateRange, refresh, dismissError, } = useDashboard();
    const [activeTab, setActiveTab] = useState('overview');
    // Handle alert acknowledge
    const handleAcknowledgeAlert = async (alertId) => {
        try {
            const token = localStorage.getItem('auth_token') || '';
            await fetch(`${import.meta.env.VITE_API_BASE_URL || 'https://coder-api.finhub.workers.dev'}/api/dashboard/alerts/acknowledge`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: JSON.stringify({ alertId }),
            });
            refresh();
        }
        catch (err) {
            console.error('Failed to acknowledge alert:', err);
        }
    };
    // Handle alert resolve
    const handleResolveAlert = async (alertId) => {
        try {
            const token = localStorage.getItem('auth_token') || '';
            await fetch(`${import.meta.env.VITE_API_BASE_URL || 'https://coder-api.finhub.workers.dev'}/api/dashboard/alerts/resolve`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: JSON.stringify({ alertId }),
            });
            refresh();
        }
        catch (err) {
            console.error('Failed to resolve alert:', err);
        }
    };
    return (_jsxs("div", { className: "min-h-screen", children: [_jsx(Header, { isConnected: isConnected, onRefresh: refresh, isLoading: isLoading }), _jsx(ErrorDisplay, { error: error, onDismiss: dismissError }), _jsx("div", { className: "bg-white border-b border-gray-200", children: _jsx("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: _jsxs("div", { className: "flex items-center gap-8", children: [_jsx("button", { onClick: () => setActiveTab('overview'), className: `py-4 px-2 border-b-2 text-sm font-medium transition-colors ${activeTab === 'overview'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'}`, children: "Overview" }), _jsx("button", { onClick: () => setActiveTab('performance'), className: `py-4 px-2 border-b-2 text-sm font-medium transition-colors ${activeTab === 'performance'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'}`, children: "Performance" })] }) }) }), _jsx("div", { className: "bg-white border-b border-gray-200", children: _jsx("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3", children: _jsxs("div", { className: "flex items-center justify-between", children: [_jsx(DateRangeFilter, { dateRange: dateRange, onDateRangeChange: setDateRange }), isLoading && (_jsxs("div", { className: "flex items-center gap-2 text-sm text-gray-500", children: [_jsx("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400" }), "Loading..."] }))] }) }) }), _jsxs("main", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6", children: [activeTab === 'overview' && (_jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-6", children: [_jsx(MetricsPanel, { metrics: metrics }), _jsx(CostPanel, { cost: cost ? { currentSpend: cost.totalCents, budgetUtilization: cost.budgetUtilization } : null }), _jsx(AlertsPanel, { alerts: alerts, onAcknowledge: handleAcknowledgeAlert, onResolve: handleResolveAlert }), _jsx("div", { className: "lg:col-span-3", children: _jsx(WorkersPanel, { workers: workers }) })] })), activeTab === 'performance' && (_jsx(PerformancePanel, { performance: performance, queries: queries, recommendations: recommendations }))] })] }));
}
